
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { IDesignatedDoctorInformationSource } from "../../../../../../documaker/domain/format/objects";
import { IDesignatedDoctorInformationSourcePropertyEditable, instanceOfIDesignatedDoctorInformationSourcePropertyEditable } from "../../../../../domain/editableFormat/properties";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import { IDesignatedDoctorType } from "../../../../../domain/editableFormat/IFormatSpecification";

@Component
export default class DesignatedDoctorInformationSourcePropertyEditableMixin  extends Mixins() {
  writePropertyWhenValid: (writer: (source: IDesignatedDoctorInformationSourcePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDesignatedDoctorInformationSourcePropertyEditable) => T, defaultValue: T) => T;

  get isDesignatedDoctorInformationSourceEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIDesignatedDoctorInformationSourcePropertyEditable(s) && s.designatedDoctorInformationSource().isEditable(), false);
  }

  get designatedDoctorInformationSource(): IDesignatedDoctorInformationSource {
    return this.readPropertyOrDefault(s => s.designatedDoctorInformationSource().getValue(), ({ type: "SHOUNIMANSEI"}));
  }

  set designatedDoctorInformationSource(value: IDesignatedDoctorInformationSource) {
    this.writePropertyWhenValid(s => s.designatedDoctorInformationSource().setValue(value));
  }

  get selectableDesignatedDoctorTypes(): IDesignatedDoctorType[] {
    return this.readPropertyOrDefault(s => s.getSelectableDesignatedDoctorTypes(), []);
  }

  get designatedDoctorTypeOptions(): StandardOption<string>[] {
    return Enumerable.from(this.selectableDesignatedDoctorTypes).select(s => new StandardOption<string>(s.name, s.code)).toArray();
  }
}
